export const getUtcTimeFormat = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        return "Invalid Date";
    }

    let hour = date.getUTCHours();      // ✅ UTC hours
    const minutes = String(date.getUTCMinutes()).padStart(2, "0"); // ✅ UTC minutes
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    return `${hour}:${minutes} ${amPm}`;
};


export const getTimeFormat = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return "Invalid Date";
    }

    let hour = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amPm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${minutes} ${amPm}`;
};


export const getLocalTimeFormate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        return "Invalid Date";
    }

    // Convert UTC date to local timezone
    const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000 * -1);

    let hour = localDate.getHours();
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    const amPm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;

    return `${hour}:${minutes} ${amPm}`;
};

export const getDateFormate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // Change 'long' to 'short'
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};

export const getDateYear = (dateString) => {
    const date = new Date(dateString);
    return date.getFullYear();
};